import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { DEFAULT_CURRENCY } from "../shared/config";

const repository = OrderRepositoryImpl.getInstance();

const queryKey = "orderSummaryForCheckout";

const useGetOrderSummaryForCheckout = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { data, isLoading } = useQuery(
    {
      queryKey: [queryKey, auth],
      queryFn: async () => {
        const orderSummaryForCheckout = await repository.getSummaryForCheckout(auth, apiUrl);
        return orderSummaryForCheckout;
      },
      enabled: Boolean(auth),
      gcTime: 0,
      initialData: {
        id: "",
        items: [],
        grossPrice: {
          amount: 0,
          currency: DEFAULT_CURRENCY,
        },
        netPrice: {
          amount: 0,
          currency: DEFAULT_CURRENCY,
        },
        salesDiscount: {
          amount: 0,
          currency: DEFAULT_CURRENCY,
        },
        balance: {
          amount: 0,
          currency: DEFAULT_CURRENCY,
        },
        promo: {
          code: "",
          percentage: 0,
          discount: {
            amount: 0,
            currency: DEFAULT_CURRENCY,
          },
        },
      },
    },
    queryClient,
  );

  return { orderSummaryForCheckout: data, isLoading };
};

export { useGetOrderSummaryForCheckout, queryKey };
